export default "__VITE_ASSET__Bvk_rP42__"